import { Address } from "../models";

export interface UpdateCustomerInput {
  full_name :  string ,
  phone :  string ,
  username :  string ,
  language :  string ,
}
export interface ChangePassword {
  currentPassword: string;
  newPassword: string;
}

export interface CreateCustomerAddressInput extends Address {
  isDefault: boolean; // By Default is false
  customerId: number;
  recipientName: string;
  contactNumber: string;
  contactCountryCode: string;
  addressTitle: string;
}

export interface UpdateCustomerAddressInput extends CreateCustomerAddressInput {
  id: number;
}

export interface AddressInput {
  first_name: string;
  last_name?: string;
  email: string;
  mobile: string;
  address_line_1: string;
  address_line_2: string;
  city?: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  note?: string;
  is_default: boolean;
  
}
export interface UpdateCAddressInput extends AddressInput {
  id?: string;
}
